import React, { cloneElement, createElement, isValidElement } from 'react';
import * as PropTypes from 'prop-types';
import Input from './Input';
import { safeHTML } from '../../../../utils/safeHTML';
import Icon from '../icon/Icon';
import classNames from 'classnames';

export default function LabelInput({
  label,
  labelAs,
  labelTextProps,
  labelProps,
  Wrapper,
  customPlaceHolder,
  children,
  ...rest
}) {
  labelTextProps = { ...labelTextProps, label };
  if (typeof labelAs === 'string') labelTextProps.children = label; //Дописывать

  return (
    <label
      {...labelProps}
      className={classNames(
        {
          checkbox: rest?.type === 'radio' || rest?.type === 'checkbox',
          checkbox_error: rest?.errorData?.[rest?.name],
        },
        labelProps?.className,
      )}
    >
      <Input
        {...rest}
        className={classNames((rest.type === 'radio' || rest.type === 'checkbox') && 'checkbox__input', rest.className)}
      >
        {rest.type === 'radio' || rest.type === 'checkbox' ? (
          <>
            <div className={'checkbox__box'}>
              <Icon name={rest.icon || 'check'} />
            </div>
            {labelAs ? (
              isValidElement(labelAs) ? (
                cloneElement(labelAs, labelTextProps)
              ) : (
                createElement(labelAs, labelTextProps)
              )
            ) : (
              <div className={rest.type === 'radio' || rest.type === 'checkbox' ? 'checkbox__text' : 'input__label'}>
                {safeHTML(label)}
              </div>
            )}
          </>
        ) : null}
        {customPlaceHolder ? <div className={'custom-placeholder'}>{customPlaceHolder}</div> : null}
        {children}
      </Input>
    </label>
  );
}

LabelInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  labelAs: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType, PropTypes.element]),
  labelTextProps: PropTypes.object,
  labelProps: PropTypes.object,
};
